import { AgResourceLanguage } from '../types';
import { quiz as EnUsQuiz } from '../en-us/quiz';

export const quiz: AgResourceLanguage['quiz'] = {
  ...EnUsQuiz,
  landing: {
    ...EnUsQuiz.landing,
    headline: 'Ta reda på om AG1 är rätt för dig',
    body: 'Den perfekta kosten existerar inte, och det ska inte kännas överväldigande att hitta rätt kosttillskott för att stödja dina dagliga näringsbehov. Klicka igenom för att lära dig hur AG1 kan stötta dig på din hälsoresa.',
    bodySubtext: '',
    caption: 'Detta verktyg är inte avsett att diagnostisera eller behandla någon sjukdom',
    start: 'Starta Nu'
  },
  chart: {
    ...EnUsQuiz.chart,
    title: 'Kom igång med ditt gratis AG1 Välkomstpaket**',
    subtitle:
      'AG1 innehåller 75 vitaminer, probiotika och ingredienser från hela livsmedel som hjälper till att bygga en grund för mental och fysisk hälsa utan att kompromissa med kvaliteten.*'
  },
  tooltip: {
    title: 'VISSTE DU?'
  },
  ensureModal: {
    title: 'Fortfarande osäker?',
    subtitle: 'Se vad andra säger om fördelarna med AG1',
    reviews: 'Läs Recensioner',
    reject: 'Nej Tack'
  },
  processModal: {
    title: 'Få senaste nytt',
    subtitle:
      'När du anmäler dig till AG1-nyheter får du tillgång till de bästa tipsen, expertråd och de senaste hälsonyheterna.',
    signUpText: 'Anmäl dig nu',
    signUpSuccess: 'Tack, du är med!',
    signUpReject: 'Nej Tack'
  },
  policy: {
    title:
      'Genom att ange din e-postadress godkänner du att ta emot marknadsföringskommunikation från Athletic Greens och att denna information behandlas enligt vår',
    button: 'Integritetspolicy'
  },
  valueChart: {
    title: 'Känn kraften av Ett',
    subtitle:
      'AG1 kombinerar 75 högkvalitativa ingredienser i en kraftfull skopa, vilket eliminerar behovet av tillskott med en enda funktion.',
    tableHead1: 'AG1 kan ersätta:',
    tableHead2: 'Kostnad per månad',
    caption:
      'Baserat på tillgängliga uppgifter för genomsnittliga industripriser för premiumtillskott',
    buttonText: 'Fortsätt'
  },
  results: {
    button: 'Prova AG1 Nu'
  }
};
